import { ReactNode } from "react";

export type Align = "left" | "right" | "center";

/**
 * A column definition for the config-driven {@link DataTable}.
 * Shaped to mirror TanStack's ColumnDef so it can move onto that engine later
 * without changing call sites.
 */
export type Column<T> = {
  key: string;
  header: ReactNode;
  tooltip?: string;
  align?: Align;
  cell: (row: T) => ReactNode;
  thClassName?: string;
  cellClassName?: string;
};

export interface ITableHeader {
  key: string;
  label: string;
  tooltip?: string;
  className?: string;
}

export const alignClass = (align?: Align): string =>
  align === "right" ? "text-right" : align === "center" ? "text-center" : "text-left";
